import IconOneGradient, {
	IconOneGradientProps as _IconOneGradientProps,
} from './IconOneGradient';

export { IconOneGradient };
export type IconOneGradientProps = _IconOneGradientProps;
